export default __webpack_public_path__ + "static/media/rockpaw.7ae8109d.png";